{
  "dodo.common.close": "Close",
  "dodo.common.continue": "Continue",
  "dodo.errors.idle.action": "Inténtalo de nuevo",
  "dodo.errors.idle.headline": "Servicio no disponible actualmente",
  "dodo.errors.idle.line1": "Vuelva a intentarlo más tarde.",
  "dodo.feedback.comments": "Please share any additional comments, suggestions or improvement opportunities. How it can be more valuable to you?",
  "dodo.feedback.description": "Your feedback is very important, so we can improve our services",
  "dodo.feedback.disclaimer.headline": "No worries, your answer will be anonymised!",
  "dodo.feedback.disclaimer.line1": "Your name and e-mail won't be linked to your answer.",
  "dodo.feedback.headline": "On a scale from 1-5, how satisfied are you with {subject}?",
  "dodo.feedback.placeholder": "Write your feedback here",
  "dodo.feedback.satisfied": "Very satisfied",
  "dodo.feedback.success.line1": "Thanks for using and contributing to our services.",
  "dodo.feedback.success.title": "Your feedback was successfully registered",
  "dodo.feedback.unsatisfied": "Very unsatisfied",
  "dodo.maintenance.actionText": "Volver a la página principal",
  "dodo.maintenance.description": "A veces, necesitamos tomar un breve descanso para realizar mantenimiento esencial y/o mejoras en nuestros servicios. Agradecemos su comprensión.",
  "dodo.maintenance.headline": "Lo siento, estamos en mantenimiento programado ahora"
}